module.exports = __webpack_public_path__ + "static/media/home-care-card-2.7ac68077.png";